import React from 'react';
import Skeleton from 'react-loading-skeleton';

const ArticlesDetailsSkeleton = () => {
  const styles = {
    top: {
      margin: 40,
    },
  };
  return (
    <div
      style={{
        display: 'flex', flexDirection: 'row',
      }}
    >
      <Skeleton count={1} height={300} width={300} borderRadius={15} style={styles.top} />
      <Skeleton count={1} height={500} width={700} borderRadius={15} style={styles.top} />
      <Skeleton count={1} height={300} width={300} borderRadius={15} style={styles.top} />
    </div>

  );
};

export default ArticlesDetailsSkeleton;
